import type { DayBookReport } from '@sellokart/shared';
import { portalApi, queryString } from '@/lib/api';
import type { ReportFilters } from './useReportFilters';

/**
 * Keyed on the branch and range only: the endpoint returns the whole range,
 * so the toolbar's search and filters narrow it on the page and must not
 * refetch.
 */
export const dayBookKeys = {
  report: (filters: Pick<ReportFilters, 'branchId' | 'from' | 'to'>) =>
    ['reports', 'day-book', filters.branchId, filters.from, filters.to] as const,
};

export function fetchDayBook(filters: ReportFilters, signal?: AbortSignal): Promise<DayBookReport> {
  const query = queryString({ branchId: filters.branchId, from: filters.from, to: filters.to });
  return portalApi.get<DayBookReport>(`/portal/reports/day-book${query}`, { signal });
}
